<nav class="sidebar" [class.collapsed]="!sidebarOpen">
  <div class="sidebar-top">
    <div class="sidebar-header">
      <div class="sidebar-logo-container">
        <img
          class="sidebar-logo-icon"
          src="assets/icons/gains-logo.svg"
          alt="GAP Logo"
          tabindex="0"
          (click)="toggleSidebar()"
          (keyup.enter)="toggleSidebar()"
          (keyup.space)="toggleSidebar()"
          role="button"
          aria-label="Toggle sidebar"
        />
        <span class="sidebar-header-text">GAP™</span>
      </div>
      <button class="sidebar-toggle" *ngIf="sidebarOpen" (click)="toggleSidebar()" aria-label="Hide sidebar">
        <img class="sidebar-toggle-icon" src="assets/icons/hide-sidebar.svg" alt="dashboard logo" />
      </button>
    </div>
    <!-- <div class="sidebar-search">
      <gains-input class="sidebar-search-input" icon="assets/icons/search.svg" suffixText="⌘ K" placeholder="Search..." ariaLabel="Search"></gains-input>
    </div> -->
  </div>
  <div class="sidebar-middle">
    <ul class="sidebar-menu">
      <li *ngFor="let item of menuItems" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <a [routerLink]="item.route" class="sidebar-menu-link">
          <img class="sidebar-menu-icon" [src]="item.icon" [attr.alt]="item.text + ' logo'" />
          <span class="sidebar-menu-text">{{ item.text }}</span>
        </a>
      </li>
    </ul>
  </div>
  <hr class="sidebar-divider" />
  <div class="sidebar-bottom">
    <ul class="sidebar-menu">
      <li *ngFor="let item of footerItems" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <a [routerLink]="item.route" class="sidebar-menu-link">
          <img class="sidebar-menu-icon" [src]="item.icon" [attr.alt]="item.text + ' logo'" />
          <span class="sidebar-menu-text">{{ item.text }}</span>
        </a>
      </li>
      <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <a [routerLink]="userItem.route" class="sidebar-menu-link-profile">
          <img class="sidebar-menu-icon" [src]="userItem.icon" alt="User logo" />
          <span class="sidebar-menu-text">{{ username }}</span>
        </a>
        <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="userMenu" class="dropdown-button" aria-label="User menu">
          <svg-icon src="assets/icons/ellipsis.svg" class="extra-icon"></svg-icon>
        </button>

        <nz-dropdown-menu #userMenu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item (click)="logout()" (keyup.enter)="logout()" (keyup.space)="logout()" tabindex="0" role="menuitem" aria-label="Logout from application">Logout</li>
          </ul>
        </nz-dropdown-menu>
      </li>
    </ul>
  </div>
</nav>
